enum LoanUnsecuredInfoProductName {
  SAGA_LIKVIDITETSRESERVE = 'SAGA Likviditetsreserve',
  DNB_FORBRUKSFINANSIERING = 'DNB Forbruksfinansiering',
}

export default LoanUnsecuredInfoProductName;
